/* =====================================================================================================================
   MJP - SPESSO ACQUISTATI INSIEME (sections/mjp-fbt.liquid)
   * Proposte: scelta manuale (gia' nella pagina) oppure API delle raccomandazioni di Shopify: prima "complementary"
     (Search & Discovery), poi, se attivo, "related". Nessuna proposta: la sezione resta nascosta.
   * L'articolo della pagina segue la variante di "MJP Product": window.MJPProduct.current() + evento "mjp:variant".
     Se e' in preordine porta con se' la proprieta' di preordine, come il pulsante principale.
   * Il pulsante aggiunge al carrello gli articoli spuntati in una sola chiamata (/cart/add.js con items[]).
   ===================================================================================================================== */
(function () {
  'use strict';
  if (window.__mjpFbt) return;
  window.__mjpFbt = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function formatMoney(cents, format) {
    cents = Math.round(+cents || 0);
    format = format || '€{{amount_with_comma_separator}}';
    function fmt(dec, th, ds) {
      var p = (cents / 100).toFixed(dec).split('.');
      return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th) + (p[1] ? ds + p[1] : '');
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount': return fmt(2, ',', '.');
        case 'amount_no_decimals': return fmt(0, ',', '.');
        case 'amount_no_decimals_with_comma_separator': return fmt(0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(2, "'", '.');
        case 'amount_with_space_separator': return fmt(2, ' ', ',');
        default: return fmt(2, '.', ',');
      }
    }).replace(/<[^>]*>/g, '');
  }

  function init(root) {
    if (root.dataset.fbtBound) return;
    root.dataset.fbtBound = '1';
    var D = root.dataset, list = root.querySelector('[data-fbt-list]');
    var btn = root.querySelector('[data-fbt-add]'), btnLabel = root.querySelector('[data-fbt-add-label]');
    var msg = root.querySelector('[data-fbt-msg]'), busy = false;
    var main = root.querySelector('[data-fbt-main]');
    var mainVariant = null; /* oggetto variante di MJP Product, se disponibile */

    function money(c) { return formatMoney(c, D.moneyFormat); }
    function items() { return Array.prototype.slice.call(list.querySelectorAll('[data-fbt-item]')); }
    function picked(li) { var c = li.querySelector('[data-fbt-check]'); return c && c.checked && !c.disabled; }
    function source(li) {
      var v = li.querySelector('[data-fbt-variant]');
      if (!v) return null;
      if (v.tagName === 'SELECT') return v.options[v.selectedIndex];
      return v;
    }
    function say(t) { msg.textContent = t || ''; msg.hidden = !t; }

    function paintItem(li) {
      var o = source(li); if (!o) return;
      var price = +o.getAttribute('data-price') || 0, cmp = +o.getAttribute('data-compare') || 0;
      li.querySelector('[data-fbt-price]').textContent = money(price);
      var s = li.querySelector('[data-fbt-compare]');
      if (s) { s.hidden = !(cmp > price); s.textContent = cmp > price ? money(cmp) : ''; }
      if (li !== main) setImg(li, o.getAttribute('data-img')); /* l'articolo della pagina: foto da MJP Product (syncMain) */
    }
    /* foto della variante: nella colonna (computer) e nella miniatura in alto (mobile) */
    function setImg(li, url) {
      url = url || li.getAttribute('data-common-img'); /* variante senza foto propria: la foto comune */
      if (!url) return;
      [li.querySelector('[data-fbt-media] img'), li._thumb && li._thumb.querySelector('img')].forEach(function (im) {
        if (!im || im.getAttribute('src') === url) return;
        im.removeAttribute('srcset'); im.removeAttribute('sizes'); im.src = url;
      });
    }

    /* Fila di miniature in alto: una per riga, nello stesso ordine, col "+" tra l'una e l'altra */
    var thumbs = root.querySelector('[data-fbt-thumbs]');
    function buildThumbs() {
      if (!thumbs) return;
      items().forEach(function (li) {
        if (li._thumb) return;
        var m = li.querySelector('[data-fbt-media]'); if (!m) return;
        var t = m.cloneNode(true);
        t.classList.add('mfbt__thumb'); t.removeAttribute('data-fbt-media');
        t.setAttribute('tabindex', '-1');
        li._thumb = t;
        thumbs.appendChild(t);
      });
    }

    function refresh() {
      var n = 0, tot = 0, cmp = 0, ok = true;
      items().forEach(function (li) {
        var on = picked(li);
        li.classList.toggle('is-on', on);
        if (!on) return;
        var o = source(li);
        if (!o || !o.value) { ok = false; return; }
        var p = +o.getAttribute('data-price') || 0, c = +o.getAttribute('data-compare') || 0;
        n++; tot += p; cmp += Math.max(p, c);
      });
      items().forEach(function (li) { if (li._thumb) li._thumb.classList.toggle('is-off', !picked(li)); });
      root.querySelector('[data-fbt-total]').textContent = money(tot);
      root.querySelector('[data-fbt-total-l]').textContent = String((n === 1 ? D.tTotalOne : D.tTotal) || '').replace('[n]', n);
      var tc = root.querySelector('[data-fbt-total-compare]');
      tc.hidden = !(cmp > tot); tc.textContent = cmp > tot ? money(cmp) : '';
      var all = items().length;
      btnLabel.textContent = String(n === 1 ? D.tOne : (n === all ? D.tAll : D.tSome) || '').replace('[n]', n);
      btn.disabled = busy || n === 0 || !ok;
      /* Spedizione gratuita, frase veritiera:
         - il set da solo supera la soglia            -> "Con questo set la spedizione e' gratuita"
         - la supera solo insieme al carrello attuale -> "Con quello che hai nel carrello la spedizione e' gratuita"
         - non la supera                              -> "Aggiungi X per la spedizione gratuita" (X calcolato su carrello + set) */
      var sh = root.querySelector('[data-fbt-ship]'), th = +D.ship || 0;
      if (sh && th > 0) {
        var inCart = +D.cartTotal || 0, left = th - (inCart + tot), txt;
        if (tot >= th) txt = D.tShipOk;
        else if (left <= 0) txt = D.tShipCart || D.tShipOk;
        else txt = String(D.tShipMore || '').replace('[amount]', money(left));
        sh.hidden = n === 0;
        sh.classList.toggle('is-ok', left <= 0);
        sh.querySelector('[data-fbt-ship-text]').textContent = txt;
      }
    }

    /* Articolo della pagina: variante scelta in MJP Product (null = opzioni non ancora scelte) */
    function syncMain(v) {
      if (!main) return;
      var input = main.querySelector('[data-fbt-variant]'), check = main.querySelector('[data-fbt-check]');
      mainVariant = v || null;
      /* foto del colore scelto in MJP Product (anche se le misure non sono ancora scelte) */
      if (window.MJPProduct && window.MJPProduct.image) setImg(main, window.MJPProduct.image(v));
      if (!v) {
        input.value = '';
        check.disabled = true;
        main.classList.add('is-pending');
        main.querySelector('[data-fbt-main-var]').textContent = D.tPick || '';
      } else {
        input.value = v.id;
        input.setAttribute('data-price', v.price);
        input.setAttribute('data-compare', v.compare_at_price || 0);
        check.disabled = !v.available;
        main.classList.toggle('is-pending', !v.available);
        main.querySelector('[data-fbt-main-var]').textContent = (v.title && v.title !== 'Default Title') ? v.title : '';
        paintItem(main);
      }
      refresh();
    }
    document.addEventListener('mjp:variant', function (e) { syncMain(e.detail && e.detail.variant); });

    function bind() {
      buildThumbs();
      items().forEach(function (li) {
        if (li.dataset.fbtWired) return;
        li.dataset.fbtWired = '1';
        var c = li.querySelector('[data-fbt-check]'); if (c) c.addEventListener('change', function () { say(''); refresh(); });
        var sel = li.querySelector('select[data-fbt-variant]'); if (sel) sel.addEventListener('change', function () { paintItem(li); refresh(); });
      });
      refresh();
    }

    btn.addEventListener('click', function () {
      if (busy) return;
      var payload = [];
      items().forEach(function (li) {
        if (!picked(li)) return;
        var o = source(li); if (!o || !o.value) return;
        var it = { id: +o.value, quantity: 1 };
        /* articolo della pagina in preordine: stessa proprieta' del pulsante principale */
        if (li === main && mainVariant && window.MJPProduct && window.MJPProduct.isPreorder && window.MJPProduct.isPreorder(mainVariant)) {
          it.properties = window.MJPProduct.props(mainVariant);
        }
        payload.push(it);
      });
      if (!payload.length) return;
      busy = true; btn.disabled = true; btn.classList.add('is-loading'); say('');
      function post(items) {
        return fetch(ROOT + 'cart/add.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); });
      }
      /* titolo di un articolo, per dire quale non e' entrato */
      function titleOf(id) {
        var t = '';
        items().forEach(function (li) { var o = source(li); if (o && +o.value === id) { var e = li.querySelector('.mfbt-row__title'); t = e ? e.textContent.replace(/^[^:]*:\s*/, '').trim() : ''; } });
        return t;
      }
      post(payload).then(function (res) {
        if (res.ok) return { added: payload.length, failed: [] };
        /* uno degli articoli non puo' entrare (es. gia' nel carrello alla quantita' massima): si prova uno per uno */
        var added = 0, failed = [];
        return payload.reduce(function (p, it) {
          return p.then(function () { return post([it]).then(function (r) { if (r.ok) added++; else failed.push(titleOf(it.id)); }); });
        }, Promise.resolve()).then(function () {
          if (!added) throw new Error((res.j && (res.j.description || res.j.message)) || '');
          return { added: added, failed: failed };
        });
      })
        .then(function (res) {
          if (res.failed.length) say(String(D.tPartial || '').replace('[n]', res.added).replace('[titoli]', res.failed.join(', ')));
          btn.classList.add('is-done');
          btnLabel.textContent = D.tAdded || '';
          document.dispatchEvent(new CustomEvent('cart:updated'));
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          fetch(ROOT + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) { D.cartTotal = c.total_price; }).catch(function () {});
          setTimeout(function () { btn.classList.remove('is-done'); busy = false; refresh(); }, 2200);
        })
        .catch(function (e) {
          busy = false;
          say((e && e.message) || D.tError || '');
          refresh();
        })
        .then(function () { btn.classList.remove('is-loading'); });
    });

    /* Proposte dall'API delle raccomandazioni (se non c'e' la scelta manuale) */
    function load(url) {
      return fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return Array.prototype.slice.call(doc.querySelectorAll('[data-fbt-items] > [data-fbt-item]'));
      }).catch(function () { return []; });
    }
    /* Anti-doppioni: si scartano le proposte il cui nome inizia come quello del prodotto (o di una gia' scelta):
       "Piercing con zirconi in Titanio F136 - ..." e "Piercing con zirconi in Titanio F136 - ..." sono alternative,
       non articoli da abbinare. Poi si tengono le prime N (impostazione "Prodotti proposti"). */
    function clean(t) { return String(t || '').toLowerCase().replace(/^\s*mjp\s*[|\-–:]\s*/, ''); } /* via il prefisso del marchio */
    function stem(t) { return clean(t).split(/\s[-–|(]\s?|[|(:,]/)[0].replace(/\s+/g, ' ').trim().slice(0, 26); }
    function cat(t) { return (clean(t).match(/[a-zà-ù]+/) || [''])[0]; } /* prima parola: piercing, orecchini, collana... */
    function pick(found) {
      var used = {}, out = [], max = +D.limit || 2, mainCat = cat(D.mainTitle), sameCat = 0;
      used[stem(D.mainTitle)] = 1;
      found.forEach(function (li) {
        if (out.length >= max) return;
        var t = li.querySelector('.mfbt-row__title'), title = t && t.textContent, k = stem(title);
        if (!k || used[k]) return;
        /* al massimo una proposta della stessa categoria del prodotto: il resto deve completarlo, non sostituirlo */
        if (mainCat && cat(title) === mainCat) { if (sameCat >= 1) return; sameCat++; }
        used[k] = 1; out.push(li);
      });
      return out;
    }
    function show(found) {
      found.forEach(function (li) { list.appendChild(document.importNode(li, true)); });
      if (found.length) { root.hidden = false; bind(); }
    }
    function ruleItems() {
      var tpl = root.querySelector('template[data-fbt-rule-items]');
      return tpl ? Array.prototype.slice.call(tpl.content.querySelectorAll('[data-fbt-item]')) : [];
    }

    if (window.MJPProduct && window.MJPProduct.current) syncMain(window.MJPProduct.current());
    function cartTotal() {
      fetch(ROOT + 'cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); })
        .then(function (c) { D.cartTotal = c.total_price || 0; refresh(); }).catch(function () {});
    }
    cartTotal();
    document.addEventListener('cart:updated', cartTotal);
    window.addEventListener('pageshow', function (e) { if (e.persisted) cartTotal(); });
    if (D.url) {
      /* complementari (Search & Discovery) -> regole per categoria -> correlati automatici */
      load(D.url).then(function (found) {
        found = pick(found);
        if (found.length) return found;
        var r = pick(ruleItems());
        if (r.length || D.related !== 'true') return r;
        return load(D.url.replace('intent=complementary', 'intent=related')).then(pick);
      }).then(show);
    } else {
      bind();
    }
  }

  function boot() { document.querySelectorAll('[data-fbt]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target && e.target.querySelector && e.target.querySelector('[data-fbt]');
    if (r) init(r);
  });
})();
